import React, { useState } from "react";
import Modal from "components/shared/ScopedModal";
import { isMobile } from "react-device-detect";
import QrStyleIcon from "./QrStyleIcon";
import SelectionUploadQrPanel from "./SelectionUploadQrPanel";
import useSelectionUploadHandoff from "./useSelectionUploadHandoff";
import { visitPrints } from "../print/openPrintSizePage";

const trackEvent = (eventName, properties = {}) => {
  if (window.MixpanelTracker?.track) {
    window.MixpanelTracker.track(eventName, properties);
  } else if (window.trackEvent) {
    window.trackEvent(eventName, properties);
  }
};

const DigitalUploadPhoneModal = ({
  createPath,
  statusPath,
  media,
  frameStyleColourId,
  frameSkuId,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const {
    handoff,
    status,
    uploadedCount,
    isCreating,
    error,
    startHandoff,
    refreshHandoff,
  } = useSelectionUploadHandoff({
    context: "digital_upload",
    createPath,
    statusPath,
    media,
    frameStyleColourId,
    frameSkuId,
    onComplete: (nextUrl) => {
      trackEvent("QR Handoff: File Received", { location: "print-and-frame" });
      visitPrints(nextUrl);
    },
  });

  if (isMobile) return null;

  const openModal = () => {
    setIsOpen(true);
    trackEvent("QR Handoff: Modal Opened", { location: "print-and-frame" });
    void startHandoff();
  };

  return (
    <>
      <div className="hidden md:block">
        <div className="mx-auto mt-6 max-w-md">
          <div className="flex items-center gap-3 text-stone-400">
            <div className="h-px flex-1 bg-stone-300" />
            <span className="text-sm">or</span>
            <div className="h-px flex-1 bg-stone-300" />
          </div>

          <div className="mt-5 flex justify-center">
            <button
              type="button"
              onClick={openModal}
              className="group inline-flex items-center gap-2.5 text-lg font-medium text-stone-700 transition hover:text-stone-900"
            >
              <QrStyleIcon className="h-6 w-6" />
              <span className="underline decoration-stone-400 underline-offset-4 transition group-hover:decoration-stone-700">
                Upload from your phone
              </span>
            </button>
          </div>
        </div>
      </div>

      <Modal
        open={isOpen}
        onClose={() => setIsOpen(false)}
        center
        classNames={{
          overlay: "selection-upload-qr-overlay",
          modal: "selection-upload-qr-modal !max-w-[562px] !rounded-lg !p-0 !shadow-2xl",
        }}
        closeIcon={
          <svg width="18" height="18" viewBox="0 0 22 22" fill="none" aria-hidden="true">
            <path d="M5 5 17 17M17 5 5 17" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
          </svg>
        }
      >
        <div className="px-8 py-8">
          <SelectionUploadQrPanel
            handoff={handoff}
            status={status}
            uploadedCount={uploadedCount}
            isLoading={isCreating}
            error={error}
            onRefresh={refreshHandoff}
          />
        </div>
      </Modal>

      <style>
        {`
          .selection-upload-qr-overlay {
            background: rgba(0, 0, 0, 0.25);
          }

          .selection-upload-qr-modal {
            margin: 0 auto;
          }
        `}
      </style>
    </>
  );
};

export default DigitalUploadPhoneModal;
